import { Input, OnChanges, SimpleChanges, HostBinding, Directive } from "@angular/core";
import { Guid } from "../../helpers/guid";

@Directive()
export abstract class BaseLinkedCollection<TCollectionRecord extends {}> implements OnChanges {
    
  @Input() sourceItems: any[]; // changed TCollectionRecord to any it was causing an error 

  @Input() allowDelete: boolean = true;

  @HostBinding('class.linked-collection') useBaseCssClass: boolean = true;

  records: TCollectionRecord[];

  constructor() {
        this.records = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
        if (changes.sourceItems) {
          this.records = (changes.sourceItems.currentValue as TCollectionRecord[]).map(x => this.decorateItem(x));
      this.onRecordChangesFromSourceItems();
    }
  }

  customTrackBy(index: number, obj: any): any {
        return obj["$$trackNumber"];
  }

  protected addNewRecord(item: TCollectionRecord) {
        const record = this.decorateItem(item);
    this.records.push(record);
    this.sourceItems.push(item);
  }

  protected onRecordChangesFromSourceItems(){
    
  }

  private decorateItem(item: TCollectionRecord): TCollectionRecord {
        const that = this;
    const handler = {};

    handler["$$item"] = item;
    handler["$$trackNumber"] = Guid.newGuid();
    handler["$$markedAsDeleted"] = false;
    handler["get"] = function (obj, prop) {
          if (prop === "$$markedAsDeleted") {
            return handler["$$markedAsDeleted"];
      }
      else if (prop === "$$trackNumber") {
            return handler["$$trackNumber"];
      }
      else {
            return obj[prop];
      }
    };

    handler["set"] = function (obj, prop, value) {
          if (prop === "$$markedAsDeleted") {
            handler["$$markedAsDeleted"] = value;
        that.toggleRecordState(this, value);
      }
      else {
            obj[prop] = value;
      }

      return true;
    };

    const proxy = new Proxy<TCollectionRecord>(item, handler);

    return proxy;
  }

  private toggleRecordState(record: any, toDelete: boolean) { // change for any it was causing an error
        const item = record["$$item"];
    if (toDelete) {
          this.sourceItems.splice(this.sourceItems.indexOf(item), 1);
    }
    else {
          this.sourceItems.push(item);
    }
  }
}